export default __webpack_public_path__ + "static/lakePoppy-a439ffb3ccfdb221767f2a7bc23cc14e.webp";